import Skeleton from 'react-loading-skeleton';
import React from 'react';
import styled, { useTheme } from 'styled-components';
import {
  FlexRow,
  MediaPlaceholderIcon,
  SvgIcon,
} from '@make-software/cspr-design';

const StyledEmptyImageContentWrapper = styled.div(({ theme }) =>
  theme.withMedia({
    display: 'inline-block',
    width: '128px',
    height: '132px',
  })
);

const SvgIconWrapper = styled.span(({ theme }) => ({
  position: 'absolute',
  path: {
    fill: theme.styleguideColors.backgroundSecondary,
  },
}));

export const EmptyMediaPlaceholder = ({
  children,
}: {
  children?: JSX.Element;
}) => (
  <FlexRow justify={'center'} align={'center'} grow={1}>
    <StyledEmptyImageContentWrapper>
      <SvgIconWrapper>
        <SvgIcon
          src={MediaPlaceholderIcon}
          role={'img'}
          alt={'Empty NFT'}
          size={132}
        />
      </SvgIconWrapper>
      {children}
    </StyledEmptyImageContentWrapper>
  </FlexRow>
);

export const LoadingMediaPlaceholder = () => {
  const theme = useTheme();

  return (
    <EmptyMediaPlaceholder>
      <Skeleton
        height={'100%'}
        width={'100%'}
        baseColor={'#ffffff00'} // use color with alpha channel to for correct working overlay
        highlightColor={theme.styleguideColors.backgroundPrimary}
        borderRadius={18}
      />
    </EmptyMediaPlaceholder>
  );
};
